/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable, throwError } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ReferenceDto } from '../models/reference-dto';
import { environment } from 'src/environments/environment';
import { FuelTypeItem } from './interfaces/fuel-type-response';

@Injectable({
  providedIn: 'root',
})
export class FuelTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation fuelTypeGetFuelTypeReferences
   */
  static readonly FuelTypeGetFuelTypeReferencesPath = '/api/nsw/fuel/reference-data';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fuelTypeGetFuelTypeReferences()` instead.
   *
   * This method doesn't expect any request body.
   */
  fuelTypeGetFuelTypeReferences$Response(params?: {}): Observable<StrictHttpResponse<Array<ReferenceDto>>> {
    const rb = new RequestBuilder(environment.nswFuelApiUrl, FuelTypeService.FuelTypeGetFuelTypeReferencesPath, 'get');

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          const body = r.body;
          const items = body?.data?.FuelTypes ?? [];
          const validItems = items.filter((item) => !!item?.Code && !!item?.Name);
          const mapped: Array<ReferenceDto> = validItems.map((item: FuelTypeItem) => ({
            code: item.Code,
            value: item.Name,
          }));
          const clone: StrictHttpResponse<Array<ReferenceDto>> = {
            ...r,
            body: mapped,
          } as StrictHttpResponse<Array<ReferenceDto>>;
          return clone;
        })
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fuelTypeGetFuelTypeReferences$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fuelTypeGetFuelTypeReferences(params?: {}): Observable<Array<ReferenceDto>> {
    return this.fuelTypeGetFuelTypeReferences$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ReferenceDto>>) => r.body as Array<ReferenceDto>)
    );
  }
}
